// src/pages/Disney.js
import React, {useEffect} from "react";
import "./Disney.css";
import Jobvid from "../components/JobVid";
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

// Import images from your assets folder.
// If your file names include spaces, you might consider renaming them for simplicity.
import bannerPhoto from "../assets/Disney Banner Photo 1.png";
import disneyIntlLogo from "../assets/Disney_International_Programs_logo 1.png";
import programInfo from "../assets/Program Informations.png";
import tellMeWhy from "../assets/tellMeWhy.png";
import videoBG1 from "../assets/DisneyVideo1.png";
import videoBG2 from "../assets/DisneyVideo_bg1.png";
import keyDiff from "../assets/section6.png";
import videoBG3 from "../assets/DisneyVideo_bg2.png";
import paymentTable from "../assets/payment.png";
import qualificationTable from "../assets/Program Qualitification.png";
import tojoin from "../assets/toJointProgram.png";
import suggest from "../assets/suggesion-info.png";

const Disney = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Disney Program | Londonhouse </title>
      </Helmet>
      {/* Banner Section */}
      <div className="banner-container">
        <div className="picture-container">
          <img src={bannerPhoto} alt="disney-banner" />
        </div>
        <div className="btn-container">
          <div className="btn1-container">
            <div className="btn-rectangle1">
              <div className="btn1-picture">
                <a href="https://jobs.disneycareers.com/disney-programs#international" target="_blank" rel="noopener noreferrer">
                  <img src={disneyIntlLogo} alt="Disney Int Programs" />
                </a>
              </div>
            </div>
          </div>
          <div className="btn2-container">
            <Link to="/activities">
              <div className="btn-rectangle2">
                <h5>Activities</h5>
                <p>Calender for Thailand</p>
              </div>
            </Link>
          </div>
          <div className="btn3-container">
            <a href="https://app.londonhouse-cm.com/app/" target="_blank" rel="noopener noreferrer">
              <div className="btn-rectangle3">
                <h5>Application Form</h5>
                <p>for Thailand</p>
              </div>
            </a>
          </div>
        </div>
      </div>
      {/* Banner Bottom Section */}
      <div className="banner-bottom">
        <div className="bottom-container">
          <div className="bottom-rectangle">
            <div className="word-con">
              <h3>DISNEY INTERNATIONAL PROGRAMS</h3>
              <p>Summer Work Experience</p>
            </div>
          </div>
        </div>
      </div>
      {/* Intro Section */}
      <div className="disney-intro-container">
        <div className="intro-header">
            <h2>Disney Cultural Exchange Program</h2>
            <div className="underline-container">
                <div className="head-underline"></div>
            </div>
        <h4>
          Rocha’s Overseas Education (London House, Chiang Mai) เปิดรับสมัครผู้สนใจเข้าร่วม
          โครงการ Disney Cultural Exchange Program
        </h4>
      </div>
        <div className="intro-paragraph">
                <p>
          สานฝันวัยเด็กสำหรับใครที่ชื่นชอบและหลงใหลใน Disney World ไม่ควรพลาด เพราะ Disney
          International Programs กลับมาแล้ว พร้อมเปิดรับสมัครฝึกงานในสวนสนุก Walt Disney World โดย
          โครงการ Disney Cultural Exchange Program เป็นโปรแกรมสำหรับนิสิต/นักศึกษาที่สนใจฝึกงานกับ
          ทาง Walt Disney World Resort, Orlando, Florida, USA
                </p>
        </div>
        </div>
        {/* Program Information Section */}
        <div class="detail-container">
            <img src={programInfo} alt="detail-table" />
        </div>
        {/* Tell Me Why Section */}
        <div class="tellMeWhy-container">
        <img src={tellMeWhy} alt="tell me why" />
        </div>
        {/* Video Section */}
        <div class="disneyVideo-container">
        <div class="video-head">
            <img src={videoBG1} alt="disney video header" />
        </div>
        <div class="video-mid-container">
            <div class="bg-container">
                <img src={videoBG2} alt="vid-bg" />
            </div>
            <div class="video-container">
                <iframe width="800" height="527" src="https://www.youtube.com/embed/U1gtrdH-DtM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
        </div>
        </div>
        {/*Job Position Video Section */}
        <Jobvid />
        { /* Key Differences Section */}
        <div class="make-diff-disney">
        <img src={keyDiff} alt="Section-info" />
        </div>
        {/* Skill Section */}
        <div className="earn-skill-container">
      {/* Header of skill Section */}
      <div className="earn-skill-head">
        <h2>การพัฒนาทักษะที่น้องๆจะได้รับ</h2>
        <div className="underline-container">
          <div className="head-underline"></div>
        </div>
        <div className="text-container">
          <p>
            การได้ร่วมเข้าโครงการ Disney Cultural Exchange Program ที่
            Walt Disney World Resort นอกเหนือจากการฝึกเกี่ยวกับหน้าที่งานที่จะต้องทำแล้ว
            น้องๆยังจะได้รับความรู้ทั้งในด้านการพัฒนาส่วนตัว และการพัฒนาด้านหน้าที่การงานในส่วนต่างๆ
            อย่างน้อย ดังนี้
          </p>
        </div>
      </div>

      {/* Skill Boxes Section */}
      <div className="skill-container">
        <div className="skill-warp-line1">
          <div className="responsibility">
            <h3>Responsibility</h3>
          </div>
          <div className="teamwork">
            <h3>Teamwork</h3>
          </div>
          <div className="networking">
            <h3>Networking</h3>
          </div>
          <div className="timeMenagement">
            <h3>Time Menagement</h3>
          </div>
          <div className="communication">
            <h3>Communication</h3>
          </div>
        </div>
        <div className="skill-warp-line2">
          <div className="coOp">
            <h3>Coporate Culture</h3>
          </div>
          <div className="problem">
            <h3>Problem Solving</h3>
          </div>
          <div className="mutiTask">
            <h3>Muti-Tasking</h3>
          </div>
          <div className="diversity">
            <h3>Diversity</h3>
          </div>
          <div className="partnering">
            <h3>Partnering</h3>
          </div>
        </div>
        <div className="skill-warp-line3">
          <div className="guest">
            <h3>Guest Sevice</h3>
          </div>
          <div className="product">
            <h3>Product Knowladge</h3>
          </div>
          <div className="profession">
            <h3>Professionalism</h3>
          </div>
        </div>
      </div>

      {/* Bottom Text Section */}
      <div className="bottom-skill">
        <div className="text-container">
          <p>
            ด้วยความแตกต่างและโดดเด่นของโครงการ Disney Cultural Exchange Program ของ
            Disney International Programs ทาง Rocha’s Overseas Education - London House ตัวแทน
            ประจำประเทศไทย มีความตั้งใจสนับสนุนและส่งเสริมให้น้องๆ ได้สร้างประสบการณ์ต่างๆ จากโอกาสที่ได้ทำงานกับบริษัทชั้นนำระดับโลก
            และหวังว่าการฝึกและการพัฒนาทักษะต่างๆ ที่ Walt Disney World Resort จัดให้ไว้ โดยไม่มีค่าใช้จ่าย
            จะเป็นประโยชน์ต่อน้องๆ ต่อไปในอนาคต
          </p>
        </div>
      </div>
    </div>
    {/* learn oveerview seection */}
    <div class="learningOverView-container">
        <div class="bg-container">
            <img src={videoBG3} alt="bg2" />
        </div>
        <div class="overView-header">
            <h2>LEARNING OVERVIEW</h2>
        </div>
        <div class="video-container">
            <iframe width="750" height="477" src="https://www.youtube.com/embed/6gjM0BKRyKo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
    </div>
    {/* Flamingo Crossing Section */}
    <div className="flamingo-crossing-container">
      <div className="flamingo-crossing-head">
        <h2>Flamingo Crossing</h2>
        <div className="underline-container">
          <div className="head-underline"></div>
        </div>
      </div>
      <div className="flamingo-crossing-video">
        <video width="1000" height="563" controls>
          <source src="https://res.cloudinary.com/dmu4pknaf/video/upload/v1774508427/Flamingo_Crossings_Village_Overview_Tour_tvkblc.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    {/* Payment Section */}
    <div class="payment-container">
        <div class="payment-info-container">
            <img src={paymentTable} alt="patment-table" />
        </div>
    </div>
    {/* Program Qualifacation Section */}
        <div class="qualification-container">
            <div class="qualification-info">
                <img src={qualificationTable} alt="qualification-table" />
            </div>
        </div>
    {/* ToJoin Section */}
        <div class="howToApply-container">
            <div class="howToApply-info">
                <img src={tojoin} alt="qualification-table" />
            </div>
        </div>
    {/* Suggestion Section */}
        <div class="suggesion-container">
    <div class="suggesion-head">
        <h2>ข้อแนะนำ</h2>
    </div>
    <div class="underline-container">
        <div class="underline"></div>
    </div>
    <div class="suggesion-info">
        <img src={suggest} alt="suggesion-table" />
    </div>
    </div>
    </div>
  );
};

export default Disney;
